const STORAGE_KEY = 'cps_dark_theme';
const LEGACY_KEY = 'cps_admin_dark_theme';

export function loadDarkTheme() {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    if (value !== null) {
      return value === '1';
    }
    const legacy = localStorage.getItem(LEGACY_KEY);
    if (legacy !== null) {
      return legacy === '1';
    }
    return false;
  } catch {
    return false;
  }
}

export function saveDarkTheme(value) {
  try {
    localStorage.setItem(STORAGE_KEY, value ? '1' : '0');
  } catch {
    // ignore
  }
}
